import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';
import { MonedaService } from '../../services/moneda.service';
import { BodegaService } from '../../services/bodega.service';
import { Moneda } from '../../model/moneda';
import { Bodega } from '../../model/bodega';
import { NgbdDatepickerPopup } from '../../bootstrap/datepicker-popup';

import { UtilitiesService } from '../../services/utilities.service';



@Component({
  selector: 'app-consorcio-mantenimiento',
  templateUrl: './consorcio-mantenimiento.component.html',
  styleUrls: ['./consorcio-mantenimiento.component.css']
})

export class ConsorcioMantenimientoComponent implements OnInit {

  @Input() consorcioSeleccionado: Consorcio;
  @Output() onReturn = new EventEmitter();

  public consorcio: Consorcio = new Consorcio();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public monedas: Moneda[];

  public bodegas: Bodega[];

  public errorMessage: any;


  constructor(
    private _consorcioService: ConsorciosService,
    private _monedaService: MonedaService,
    private _bodegaService: BodegaService,
    private _utilities: UtilitiesService,    
    private localStorageService: LocalStorageService
  ) { }


  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    if (this.consorcioSeleccionado != null) {
      this.consorcio = this.consorcioSeleccionado;
      this.estadoEditar = true;
    }

    this._bodegaService.getBodegas()
      .subscribe(
      data => this.bodegas = data,
      err => {
        console.log(err);
      });

    this._monedaService.getMonedas()
      .subscribe(
      monedas => this.cargarApiMoneda(monedas),
      err => {
        console.log(err);
      });

  }


  cargarApiMoneda(data: Moneda[]) {
    this.monedas = data;
  }

  onSubmit() {
    if (this.consorcio.id === undefined) {
      this.consorcio.id = 0;
    }

    this._consorcioService.insert(this.consorcio).subscribe(
      result => { 
        if(result.Resultado === "codigoConsorcio ya existe en la base de datos"){
            alert("El código del Consorcio ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.log(err);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }
  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  onSelectionDone(value) {
    this.consorcio.vigenciaContrato = value;
    console.log(this.consorcio.vigenciaContrato);
  }

  borrarRegistro() {
    this._consorcioService.delete(this.consorcio).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/consorcio-mantenimiento/consorcio-mantenimiento.component.ts